
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import { useFetch } from "../../../hooks/useFetch";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const EventsList = ({
  pageActual,
  limitList, startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  buscar_cis,
  loadingList,
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  // var dataList=(searchTerm==='')?dataUsers.data:searchResults;
  const dataCriticalities = useFetch('cassia/criticalities', '', localStorage.getItem('access_token'), 'GET', server)
  function getNameById(arr, id) {
    const item = arr.find(el => el.id === id);
    return item ? item.name : null;
  }
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({})
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {

    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  return (
    <>
      <div className="cont-row-user-list">
        {loadingList || dataCriticalities.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .filter(elemento => elemento.active === 1)
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio" + mode}
                key={indice}
                style={{ height: '45px' }}
              >

                <div className="field-body-table-mantenimiento field-medium">
                  {elemento.event_id}
                </div>
                <div className="field-body-table-mantenimiento field-larger"   >
                  {elemento.trigger_id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '22%' }} >
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '22%' }}>
                  {elemento.description}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{ width: '22%' }}>
                  {elemento.event_message}
                </div>
                <div className="field-body-table-mantenimiento field-larger" >
                  {getNameById(dataCriticalities.data.data, elemento.severity_default_id)}
                </div>


                <div className="field-body-table-mantenimiento field-larger">
                  {

                    <>
                      {/* <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div> */}

                      <div style={{ width: '33%' }}>
                        <img
                          src={
                            "/iconos/delete.png"
                          }
                          onClick={() => handledeleteUserClick(elemento)}
                          name="Eliminar" title='Eliminar' className="btnAction delteException" style={{ width: '45%' }}
                        />
                      </div>
                    </>
                  }

                </div>
              </div>
            ))
        )}
        {dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
        <ModalDeleteBrand handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
      </Modal>
    </>
  );
};

export default EventsList;
